document.addEventListener("DOMContentLoaded", function () {
  let buffer = "";
  const targetWord = "unicorn";

  document.addEventListener("keydown", function (e) {
    // Only track letters a-z (ignores Shift, Tab, etc.)
    if (/^[a-zA-Z]$/.test(e.key)) {
      buffer += e.key.toLowerCase();

      // Keep only the last N characters (length of the target word)
      if (buffer.length > targetWord.length) {
        buffer = buffer.slice(-targetWord.length);
      }

      // Check for match
      if (buffer === targetWord) {
        alert("🦄 You found the Easter egg! Use code UNICORN10 at checkout!");
        // Optionally reset the buffer
        buffer = "";
      }
    }
  });
});
